import { render } from "./BaseCSS.vue?vue&type=template&id=5c85ede5"
const script = {}

import "./BaseCSS.vue?vue&type=style&index=0&id=5c85ede5&lang=scss"
script.render = render

export default script